import { Component, Input, OnInit, Output, EventEmitter, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";

// interface Option {
//   label: string;
//   value: any;
//   i18nKey?: string;
// }
type Condition = "include" | "exclude";
type EmitValue = [Condition, any[]];

export const CONDITION_SWITCH_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ConditionSwitchPickerComponent),
  multi: true,
};

@Component({
  selector: "host-condition-switch-picker",
  templateUrl: "./condition-switch-picker.component.html",
  styleUrls: ["./condition-switch-picker.component.scss"],
  providers: [CONDITION_SWITCH_PICKER_VALUE_ACCESSOR],
})
export class ConditionSwitchPickerComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder = this.t.syncGet("reservation.list.filters.filter_tag.placeholder");
  // @Input() placeholder = this.t.syncGet('component.condition_switch.placeholder');
  @Input() listOfOption: Option[] = [];
  listOfConditions: Option[] = [
    { label: "包含所选项", value: "include", i18nKey: "component.condition_switch.option.include" },
    { label: "排除所选项", value: "exclude", i18nKey: "component.condition_switch.option.exclude" },
  ];

  visible = false;
  condition: Condition = "include";
  selected: Set<any> = new Set();
  // renderText;
  trackByValue = (opt) => opt.value;

  _registerOnChange: (value: any) => void = (_: any) => {};

  get renderText() {
    return this.visible ? null : this.getRenderText();
  }

  constructor(private t: TranslateService) {}

  ngOnInit() {}

  onClickItem(item: Option) {
    if (this.selected.has(item.value)) {
      this.selected.delete(item.value);
    } else {
      this.selected.add(item.value);
    }
  }

  onClickCancel() {
    this.visible = false;
  }

  onClickConfirm() {
    this.visible = false;
    // 防止不点击condition按钮，直接点击items导致condition为空的问题
    if (!this.condition) {
      this.condition = "include";
    }
    // this.renderText = this.getRenderText();
    this._registerOnChange([this.condition, Array.from(this.selected)]);
  }

  onClickReset() {
    this.condition = "include";
    this.selected.clear();
  }

  private getRenderText() {
    // const prefix = this.condition === 'include' ? '包含' : '排除';
    const selectedSize = this.selected.size;
    if (selectedSize === 0) {
      return null;
    }
    if (selectedSize === this.listOfOption.length) {
      return this.t.t(`component.condition_switch.unit.${this.condition}_all`);
      // return prefix + '全部'
    }
    // if (selectedSize === 1) {
    //   const item = this.listOfOption.find(opt => this.selected.has(opt.value));
    //   return prefix + item.label;
    // }
    if (selectedSize > 1) {
      return this.t.t(`component.condition_switch.unit.${this.condition}`, {
        number: selectedSize,
      });
    } else {
      return this.t.t(`component.condition_switch.unit.${this.condition}_singular`, {
        number: selectedSize,
      });
    }
    // return prefix + selectedSize + '个';
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  writeValue(value: EmitValue): void {
    if (value) {
      this.condition = value[0];
      this.selected = new Set(value[1]);
      // this.renderText = this.getRenderText();
    } else {
      this.condition = "include";
      this.selected = new Set();
      // this.renderText = null;
    }
  }

  registerOnTouched(fn: any): void {}
}
